<template>
  <div class="work-responsibilities">
    <h4 ref="title">Project responsibilities</h4>
    <ul class="list-responsibilities">
      <li
        v-for="item in responsibilities"
        :key="item.id"
        ref="responsibility"
      >{{ item.responsibility }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    responsibilities: Array
  }
};
</script>

<style lang="scss" scoped>
.work-responsibilities {
  position: relative;
  overflow: hidden;
}
ul.list-responsibilities {
  padding: 0;
  margin: 0;
  list-style: none;
  color: #888888;
}
</style>